import { notify, confirm } from '../../utils/notify';
import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { vendorAPI } from '../../services/api';
import { useListControls, ListToolbar, Pagination } from '../../components/ListControls';
import Topbar from "../../components/Topbar";

const money = n => new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(Number(n)||0);

function GRNVerification() {
  const [grnList, setGrnList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);
  
  const [editModal, setEditModal] = useState(null);
  const [form, setForm] = useState({grn1ReceivedQty:0,grn1AcceptedQty:0,grn2ReceivedQty:0,grn2AcceptedQty:0,remarks:''});

  const load = () => { setLoading(true); vendorAPI.listGRN().then(d=>setGrnList(d.grnList||[])).catch(()=>{}).finally(()=>setLoading(false)); };
  useEffect(()=>{ load(); },[]);
  

  const handleUpdate = async () => {
    if (!editModal) return;
    setSaving(editModal._id);
    try {
      await vendorAPI.updateGRN(editModal._id, form);
      notify.success('GRN updated! Payable amount recalculated.');
      setEditModal(null); await load();
    } catch(e) { notify.error(e.message); } finally { setSaving(null); }
  };

  const statusCls = {PENDING:'status-pending',PARTIAL:'status-inreview',COMPLETE:'status-approved'};
  const lc = useListControls(grnList, { searchFields: [g=>g.vendorId?.name, 'grnCode'], dateField: 'createdAt', pageSize: 10 });

  return (
    <>
      <Header/>
      <div id="db-wrapper"><main id="page-content">
          <Topbar section="Vendor Payment" /><section className="container-fluid p-4 pt-3">
        

        <div className="page-hero d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div><h5 className="text-white lh-1">GRN Verification</h5><div className="sub">Step 5 — Verify GRN. Payment based on Accepted GRN Quantity, NOT Invoice Quantity.</div></div>
          <div style={{background:'rgba(255,255,255,0.15)',borderRadius:10,padding:'4px 11px',fontSize:'0.736rem',color:'#fff'}}><i className="bi bi-info-circle me-1"/>GRN Based Payment</div>
        </div>

        <div className="row g-2 mb-3">
          {[{l:'Pending GRN',v:grnList.filter(g=>g.status==='PENDING').length,bg:'#fef2f2',ic:'#ef4444'},{l:'Partial',v:grnList.filter(g=>g.status==='PARTIAL').length,bg:'#fffbeb',ic:'#f59e0b'},{l:'Complete',v:grnList.filter(g=>g.status==='COMPLETE').length,bg:'#f0fdf4',ic:'#22c55e'},{l:'Total',v:grnList.length,bg:'#eff6ff',ic:'#3b82f6'}].map((s,i)=>(
            <div key={i} className="col-6 col-md-3"><div className="kpi-card d-flex align-items-center gap-2"><div className="kpi-icon" style={{background:s.bg}}><i className="bi bi-box-seam" style={{color:s.ic}}/></div><div><div style={{fontSize:'1.17rem',fontWeight:700}}>{s.v}</div><div style={{fontSize:'0.7rem',color:'#6b7280'}}>{s.l}</div></div></div></div>
          ))}
        </div>

        {loading?<div className="text-center py-5"><span className="spinner-border text-primary"/></div>
        :grnList.length===0?<div className="empty-state"><i className="bi bi-box-seam"/><p>No GRN records found</p></div>
        :(<>
        <ListToolbar search={lc.search} setSearch={lc.setSearch} dateFrom={lc.dateFrom} setDateFrom={lc.setDateFrom} dateTo={lc.dateTo} setDateTo={lc.setDateTo} placeholder="Search by vendor, GRN code..." dateLabel="Created"/>
        {lc.paginated.map((g,idx)=>(
          <div key={g._id} className="record-card">
            <div className="record-number">{(lc.page-1)*lc.pageSize+idx+1}.</div>
            <div className="record-body">
              <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
                <div style={{fontWeight:700,fontSize:'0.874rem',color:'#111827'}}>{g.vendorId?.name||'—'}</div>
                <span className={`status-pill ${statusCls[g.status]||'status-pending'}`}>{g.status}</span>
                <span style={{background:'#f0fdf4',color:'#16a34a',fontSize:'0.7rem',fontWeight:600,padding:'2px 6px',borderRadius:12}}>{money(g.payableAmount)}</span>
              </div>
              <div className="row g-2">
                <div className="col-12 col-md-3">
                  <div className="record-field"><span className="rf-label">GRN Code — </span><span className="rf-value text-primary">{g.grnCode}</span></div>
                  <div className="record-field"><span className="rf-label">Invoice Qty — </span><span className="rf-value">{g.invoiceQty}</span></div>
                  <div className="record-field"><span className="rf-label">Unit Price — </span><span className="rf-value">{money(g.unitPrice)}</span></div>
                </div>
                <div className="col-12 col-md-3">
                  <div style={{fontSize:'0.7rem',color:'#9ca3af',fontWeight:600,marginBottom:4}}>GRN 1</div>
                  <div className="record-field"><span className="rf-label">Received — </span><span className="rf-value">{g.grn1ReceivedQty}</span></div>
                  <div className="record-field"><span className="rf-label">Accepted — </span><span className="rf-value fw-bold text-success">{g.grn1AcceptedQty}</span></div>
                </div>
                <div className="col-12 col-md-3">
                  <div style={{fontSize:'0.7rem',color:'#9ca3af',fontWeight:600,marginBottom:4}}>GRN 2</div>
                  <div className="record-field"><span className="rf-label">Received — </span><span className="rf-value">{g.grn2ReceivedQty}</span></div>
                  <div className="record-field"><span className="rf-label">Accepted — </span><span className="rf-value fw-bold text-success">{g.grn2AcceptedQty}</span></div>
                </div>
                <div className="col-12 col-md-3">
                  <div className="record-field"><span className="rf-label">Total Accepted — </span><span className="rf-value fw-bold">{g.totalAcceptedQty}/{g.invoiceQty}</span></div>
                  <div className="record-field"><span className="rf-label">Payable — </span><span className="rf-value fw-bold text-primary">{money(g.payableAmount)}</span></div>
                  {g.remarks&&<div className="record-field"><span className="rf-label">Remarks — </span><span className="rf-value">{g.remarks}</span></div>}
                </div>
              </div>
            </div>
            <div className="divider d-none d-md-block"/>
            <div className="record-actions">
              <button className="btn-card-view" onClick={()=>{setEditModal(g);setForm({grn1ReceivedQty:g.grn1ReceivedQty||0,grn1AcceptedQty:g.grn1AcceptedQty||0,grn2ReceivedQty:g.grn2ReceivedQty||0,grn2AcceptedQty:g.grn2AcceptedQty||0,remarks:g.remarks||''});}}>Update GRN</button>
            </div>
          </div>
        ))}
        <Pagination page={lc.page} totalPages={lc.totalPages} setPage={lc.setPage} totalCount={lc.totalCount} pageSize={lc.pageSize} itemLabel="GRN records"/>
        </>)}

        {editModal&&(
          <div className="modal show d-block" style={{background:'rgba(0,0,0,0.45)'}}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content shadow-lg">
                <div className="modal-header border-0"><h5 className="fw-bold">Update GRN — {editModal.grnCode}</h5><button className="btn-close" onClick={()=>setEditModal(null)}/></div>
                <div className="modal-body">
                  <div style={{padding:'7px 10px',background:'#fffbeb',borderRadius:8,marginBottom:8,fontSize:'0.736rem',color:'#92400e',border:'1px solid #fcd34d'}}>Invoice Qty: <b>{editModal.invoiceQty}</b> | Unit Price: <b>{money(editModal.unitPrice)}</b></div>
                  <div className="row g-2">
                    <div className="col-12" style={{fontWeight:700,fontSize:'0.754rem',color:'#374151'}}>GRN 1</div>
                    <div className="col-6"><label className="form-label small fw-semibold">Received Qty</label><input type="number" className="form-control" value={form.grn1ReceivedQty} onChange={e=>setForm(p=>({...p,grn1ReceivedQty:Number(e.target.value)}))}/></div>
                    <div className="col-6"><label className="form-label small fw-semibold">Accepted Qty</label><input type="number" className="form-control" value={form.grn1AcceptedQty} onChange={e=>setForm(p=>({...p,grn1AcceptedQty:Number(e.target.value)}))}/></div>
                    <div className="col-12" style={{fontWeight:700,fontSize:'0.754rem',color:'#374151'}}>GRN 2</div>
                    <div className="col-6"><label className="form-label small fw-semibold">Received Qty</label><input type="number" className="form-control" value={form.grn2ReceivedQty} onChange={e=>setForm(p=>({...p,grn2ReceivedQty:Number(e.target.value)}))}/></div>
                    <div className="col-6"><label className="form-label small fw-semibold">Accepted Qty</label><input type="number" className="form-control" value={form.grn2AcceptedQty} onChange={e=>setForm(p=>({...p,grn2AcceptedQty:Number(e.target.value)}))}/></div>
                    <div className="col-12">
                      <div style={{padding:'7px 10px',background:'#f0fdf4',borderRadius:8,fontSize:'0.754rem',border:'1px solid #bbf7d0'}}>
                        Total Accepted: <b>{form.grn1AcceptedQty+form.grn2AcceptedQty}</b> | Payable: <b>{money((form.grn1AcceptedQty+form.grn2AcceptedQty)*editModal.unitPrice)}</b>
                      </div>
                    </div>
                    <div className="col-12"><label className="form-label small fw-semibold">Remarks</label><input className="form-control" value={form.remarks} onChange={e=>setForm(p=>({...p,remarks:e.target.value}))}/></div>
                  </div>
                </div>
                <div className="modal-footer border-0 gap-2">
                  <button className="btn btn-light rounded-3 px-4" onClick={()=>setEditModal(null)}>Cancel</button>
                  <button className="btn rounded-3 px-5 fw-semibold" style={{background:'linear-gradient(135deg,#1a5276,#1e8449)',color:'#fff',border:'none'}} onClick={handleUpdate} disabled={!!saving}>
                    {saving?<span className="spinner-border spinner-border-sm"/>:'Update GRN'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </section></main></div>
    </>
  );
}
export default GRNVerification;
